module.exports = __webpack_public_path__ + "img/562.0d7fdede.jpg";